import React from 'react';
import Amount from 'design-system/Amount';
import useColors from 'hooks/useColors';
const AccountBalance = ({ amount, currency, color }) => {
    const colors = useColors();
    return (<Amount color={color || colors.text.income} Numbers-16 value={{ value: amount, currency }}/>);
};
export default AccountBalance;
